import { ItemTypeConsts } from 'client/util/Constants';
import GettingStartedPanelSettings from 'client/components/GettingStartedPanel/GettingStartedPanelSettings';

const UserAsidePanel = () => import('client/systemusers/UserDetails/UserAsidePanel.vue');
const UserManagementPage = () => import('client/systemusers/SystemUserItemTable/UserManagement/UserManagementPage.vue');
const UsersDetailsDownloadModal = () => import('client/systemusers/components/UsersDetailsDownloadModal.vue');
const UsersMainPanel = () => import('client/systemusers/UsersMainPanel.vue');

const userProps = {
  asidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.systemUser,
  },
  mainPanel: {
    gettingStartedPanelItemType: ItemTypeConsts.systemUser,
    isAsideOpen: false,
    itemType: ItemTypeConsts.systemUser,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'Users',
  tooltipProps: {
    linkHref: GettingStartedPanelSettings[ItemTypeConsts.systemUser]({}).learnMoreUrl,
    pText: GettingStartedPanelSettings[ItemTypeConsts.systemUser]({}).tooltipText,
  },
};

export default [
  {
    path: '/users',
    name: 'users',
    meta: metaData,
    components: {
      mainPanel: UsersMainPanel,
    },
    props: userProps,
  },
  {
    path: '/users/add',
    name: 'newUser',
    meta: metaData,
    components: {
      mainPanel: UsersMainPanel,
      asidePanel: UserAsidePanel,
    },
    props: {
      mainPanel: userProps.mainPanel,
      asidePanel: route => ({
        ...userProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/users/add/:initialTab',
    name: 'newUserInitialTab',
    meta: metaData,
    components: {
      mainPanel: UsersMainPanel,
      asidePanel: UserAsidePanel,
    },
    props: {
      mainPanel: userProps.mainPanel,
      asidePanel: route => ({
        ...userProps.asidePanel,
        itemId: route.params.id,
        navigateToTab: { tabLabel: route.params.initialTab },
      }),
    },
  },
  {
    path: '/users/:id/details',
    name: 'userDetails',
    meta: metaData,
    components: {
      mainPanel: UsersMainPanel,
      asidePanel: UserAsidePanel,
    },
    props: {
      mainPanel: userProps.mainPanel,
      asidePanel: route => ({
        ...userProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/users/:id/details/:initialTab',
    name: 'userDetailsInitialTab',
    meta: metaData,
    components: {
      mainPanel: UsersMainPanel,
      asidePanel: UserAsidePanel,
    },
    props: {
      mainPanel: userProps.mainPanel,
      asidePanel: route => ({
        ...userProps.asidePanel,
        itemId: route.params.id,
        navigateToTab: { tabLabel: route.params.initialTab },
      }),
    },
  },
  {
    path: '/users/settings',
    name: 'userSettings',
    meta: metaData,
    components: {
      mainPanel: UserManagementPage,
    },
  },
  {
    path: '/users/jobs/:id/detailedImportResults',
    name: 'userImportDetails',
    components: {
      mainPanel: UsersDetailsDownloadModal,
    },
    props: {
      mainPanel: route => ({
        id: route.params.id,
      }),
    },
  },
];
